import React, { Component, Fragment } from "react";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router-dom";

import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";
import Heading from "../../components/Heading";
import ConversationList from "../../components/messages/ConversationList/ConversationList";
import ConversationDetail from "../../components/messages/ConversationDetail/ConversationDetail";

import "./MessagesInbox.css";

@inject("conversationStore", "profileStore")
@withRouter
@observer
class MessagesInbox extends Component {
    state = {
        selectedConversationId: null,
        isComposing: false,
        mobileShowDetail: false
    };

    componentDidMount() {
        this.props.conversationStore.load();
        
        const { conversationId } = this.props.match.params;
        if (conversationId && conversationId !== "new") {
            this.setState({ selectedConversationId: parseInt(conversationId) });
        } else if (conversationId === "new") {
            this.setState({ isComposing: true });
        }
    }

    componentDidUpdate(prevProps) {
        const { conversationId } = this.props.match.params;
        const prevConversationId = prevProps.match.params.conversationId;
        
        if (conversationId !== prevConversationId) {
            if (conversationId === "new") {
                this.setState({ selectedConversationId: null, isComposing: true, mobileShowDetail: true });
            } else if (conversationId) {
                this.setState({ selectedConversationId: parseInt(conversationId), isComposing: false, mobileShowDetail: true });
            } else {
                this.setState({ selectedConversationId: null, isComposing: false, mobileShowDetail: false });
            }
        }
    }

    handleSelectConversation = (conversationId) => {
        this.setState({ 
            selectedConversationId: conversationId, 
            isComposing: false,
            mobileShowDetail: true 
        });
        this.props.history.push(`/messages/${conversationId}`);
    };

    handleNewMessage = () => {
        this.setState({ 
            selectedConversationId: null, 
            isComposing: true,
            mobileShowDetail: true 
        });
        this.props.history.push("/messages/new");
    };

    handleBackToList = () => {
        this.setState({ mobileShowDetail: false });
        this.props.history.push("/messages");
    };

    handleMessageSent = (conversationId) => {
        this.props.conversationStore.load();
        this.setState({ 
            selectedConversationId: conversationId, 
            isComposing: false 
        });
        this.props.history.push(`/messages/${conversationId}`);
    };

    render() {
        const { conversations, isLoading } = this.props.conversationStore;
        const currentProfile = this.props.profileStore.getCurrentProfile();
        const { selectedConversationId, isComposing, mobileShowDetail } = this.state;

        return (
            <Fragment>
                <Header />
                <Sidebar />
                <MainContainer>
                    <Heading title="Messages" />
                    <div className="messages-inbox">
                        <div className={`messages-inbox-container ${mobileShowDetail ? 'mobile-show-detail' : ''}`}>
                            <div className="conversation-list-panel">
                                <ConversationList
                                    conversations={conversations}
                                    selectedId={selectedConversationId}
                                    isLoading={isLoading}
                                    onSelectConversation={this.handleSelectConversation}
                                    onNewMessage={this.handleNewMessage}
                                    currentProfile={currentProfile}
                                />
                            </div>
                            <div className="conversation-detail-panel">
                                <ConversationDetail
                                    conversationId={selectedConversationId}
                                    isComposing={isComposing}
                                    onBackToList={this.handleBackToList}
                                    onMessageSent={this.handleMessageSent}
                                    currentProfile={currentProfile}
                                    prePopulateRecipient={this.props.location.state?.profile}
                                />
                            </div>
                        </div>
                    </div>
                </MainContainer>
            </Fragment>
        );
    }
}

export default MessagesInbox;
